<div class="flex flex-wrap gap-4 mb-4">
  <app-total-fee-card [totalFeeCard]="serviceSumFeesCard()" />
  <app-total-fee-card [totalFeeCard]="implementationActivitySumFeesCard()" />
  <app-total-fee-card [totalFeeCard]="integrationSetupSumFeesCard()" />
  <app-total-fee-card [totalFeeCard]="integrationOtherSumFeesCard()" />
  <app-total-fee-card [totalFeeCard]="totalSumFeesCard()" />
</div>

<div class="flex flex-col gap-4">
  <app-company-employee-info-module [inputObject]="companyEmployeesContainer()" />

  <app-service-fees-module
    [inputObject]="serviceFeesContainer()"
    [(sumFeesModel)]="serviceSumFees"
    [isReadOnly]="isReadOnly()"
    (submitOutput)="saveServiceFees($event)"
  />

  <app-implementation-fees-module
    [inputObject]="implementationFeesContainer()"
    [moduleFunctionMap]="moduleFunctionMap()"
    [(sumFeesModel)]="implementationActivitySumFees"
    [isReadOnly]="isReadOnly()"
    (submitOutput)="saveImplementationFees($event)"
  />

  <app-integration-setup-fees-module
    [isCustomerType]="isCustomerType()"
    [inputObject]="integrationSetupFeesContainer()"
    [(sumFeesModel)]="integrationSetupSumFees"
    [isReadOnly]="isReadOnly()"
    (submitOutput)="saveIntegrationSetupFees($event)"
  />

  <app-integration-other-fees-module
    [inputObject]="integrationOtherFeesContainer()"
    [(sumFeesModel)]="integrationOtherSumFees"
    [isReadOnly]="isReadOnly()"
    (submitOutput)="saveIntegrationOtherFees($event)"
  />

  <app-total-fees-module
    [inputObject]="totalFeesContainer()"
    [(sumFeesModel)]="totalModuleSumFees"
  ></app-total-fees-module>
</div>

@if (isDraft()) {
  <div
    class="pointer-events-none fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-300 text-9xl font-bold opacity-5 select-none -rotate-45 z-0 whitespace-nowrap text-[16rem]"
  >
    {{ 'common.preview' | transloco }}
  </div>
}
